<template>
  <div class="mt-20 attendance-table-container">
    <div class="attendance-header-container mb-10">
      <h6 class="font-weight-bold mb-0">
        <a-icon type="reconciliation" class="mr-10" />รายการบันทึกเวลาทำงานทั้งหมด
      </h6>
      <a-pagination
        v-if="countObjDataA > perPageA"
        :current="currentPageA"
        :total="countObjDataA"
        :pageSize="perPageA"
        @change="onChangePageA"
        size="small"
      />
    </div>
    <a-table
      class="mb-20 attendance-custom-table"
      :columns="columnsAttandance"
      :data-source="dataAttandance"
      :pagination="false"
      :loading="loadingA"
      bordered
      size="small"
    >
      <template slot="date" slot-scope="text, record">
        {{ moment(record.created_at).locale('th').add(543, 'years').format("DD MMMM YYYY") }}
      </template>
      <template slot="timeIN" slot-scope="text, record">
        <span :class="text !== '-' ? 'text-success font-weight-bold' : 'text-muted'">{{ text }}</span>
        <small v-if="record.locationIN !== '-'" class="text-muted ml-5" style="font-size: 0.8em;">( {{ record.locationIN }} )</small>
      </template>
      <template slot="timeOUT" slot-scope="text, record">
        <span :class="text !== '-' ? 'text-danger font-weight-bold' : 'text-muted'">{{ text }}</span>
        <small v-if="record.locationOUT !== '-'" class="text-muted ml-5" style="font-size: 0.8em;">( {{ record.locationOUT }} )</small>
      </template>
    </a-table>
    <div class="attendance-footer-container">
      <a-pagination
        v-if="countObjDataA > perPageA"
        class="mb-10 mt-5"
        :current="currentPageA"
        :total="countObjDataA"
        :pageSize="perPageA"
        @change="onChangePageA"
        size="small"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
const columnsAttandance = [
  {
    title: "Date",
    dataIndex: "date",
    scopedSlots: { customRender: "date" },
    width: "25%",
    className: "font-weight-bold text-center",
  },
  {
    title: "Time IN",
    dataIndex: "timeIN",
    scopedSlots: { customRender: "timeIN" },
    width: "20%",
    className: "text-center",
  },
  {
    title: "Time OUT",
    dataIndex: "timeOUT",
    scopedSlots: { customRender: "timeOUT" },
    width: "20%",
    className: "text-center",
  },
];
export default {
  data() {
    return {
      columnsAttandance,
      dataAttandance: [],
      loadingA: false,
      // pagination
      perPageA: 100,
      countObjDataA: 0,
      currentPageA: 1,
      offsetA: 0,
    };
  },
  mounted() {
    this.getListAttandance();
  },
  methods: {
    onChangePageA(current) {
      this.currentPageA = current;
      this.offsetA = Number.parseInt(current - 1) * Number.parseInt(this.perPageA);
      this.getListAttandance();
    },
    async getListAttandance() {
      this.loadingA = true;
      this.dataAttandance = [];
      try {
        const res = await this.$http.get(
          `/hri/time_attendance/?limit=${this.perPageA}&offset=${this.offsetA}`
        );
        if (res.status === 200) {
          const grouped = {};
          res.data.results.forEach(item => {
            const dateStr = moment(item.created_at).format('YYYY-MM-DD');
            if (!grouped[dateStr]) {
              grouped[dateStr] = [];
            }
            grouped[dateStr].push(item);
          });

          this.dataAttandance = Object.keys(grouped).map(dateKey => {
            const dayRecords = grouped[dateKey].sort((a, b) => moment(a.created_at) - moment(b.created_at));
            let timeIN = '-';
            let timeOUT = '-';
            let locationIN = '-';
            let locationOUT = '-';

            if (dayRecords.length > 1) {
              timeIN = moment(dayRecords[0].created_at).format('HH:mm:ss');
              locationIN = dayRecords[0].location || '-';
              timeOUT = moment(dayRecords[dayRecords.length - 1].created_at).format('HH:mm:ss');
              locationOUT = dayRecords[dayRecords.length - 1].location || '-';
            } else if (dayRecords.length === 1) {
              const recordTime = moment(dayRecords[0].created_at);
              if (recordTime.hour() < 12) {
                timeIN = recordTime.format('HH:mm:ss');
                locationIN = dayRecords[0].location || '-';
              } else {
                timeOUT = recordTime.format('HH:mm:ss');
                locationOUT = dayRecords[0].location || '-';
              }
            }

            return {
              key: dateKey,
              date: dateKey,
              created_at: dayRecords[0].created_at,
              timeIN: timeIN,
              locationIN: locationIN,
              timeOUT: timeOUT,
              locationOUT: locationOUT,
              remark: dayRecords.map(r => r.remark).filter(r => r).join(', ') || '-'
            };
          });

          this.countObjDataA = res.data.count;
          this.loadingA = false;
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.dataAttandance = [];
        this.loadingA = false;
        this.$notification.open({
          style: {
            backgroundColor: `#ff1919`,
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [h("strong", { class: "" }, `Error ${error.response.status}`)]);
          },
          description: `Problem issue connect api : /hri/time_attendance/?limit=${this.perPageA}&offset=${this.offsetA}`,
        });
      }
    },
  },
};
</script>

<style scoped>
.attendance-custom-table >>> .ant-table-thead > tr > th {
  background-color: #000000 !important;
  color: #ffffff !important;
  font-weight: bold !important;
  text-align: center !important;
  font-size: 1.1em !important;
}
.attendance-header-container,
.attendance-footer-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.attendance-footer-container {
  justify-content: flex-end;
}
.font-weight-bold {
  font-weight: bold;
}
</style>